import { css } from 'emotion';

export namespace styles {
  export const container = css({
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: 100,
    backgroundColor: 'white'
  });
}
